// extracted by mini-css-extract-plugin
export default {"coverLink":"LL-z","contentBox":"ML-z","zapposPromoContainer":"NL-z","zapposPromoGroupContainer":"OL-z","promos":"PL-z","bottom":"QL-z","top":"RL-z","right":"SL-z","left":"TL-z"};